/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Addnotesforcommittee4Inputs */

const en_coinvestments_addnotesforcommittee4 = /** @type {(inputs: Coinvestments_Addnotesforcommittee4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add notes for committee`)
};

/**
* | output |
* | --- |
* | "Add notes for committee" |
*
* @param {Coinvestments_Addnotesforcommittee4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_addnotesforcommittee4 = /** @type {((inputs?: Coinvestments_Addnotesforcommittee4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Addnotesforcommittee4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_addnotesforcommittee4(inputs)
});
export { coinvestments_addnotesforcommittee4 as "coInvestments_addNotesForCommittee" }